import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-annotation', 'open', 'Atvērt anotāciju');
Labels.set('ui-annotation', 'close', 'Aizvērt anotāciju');
